import React, { ReactNode } from 'react';
import clsx from 'clsx';
import { HourglassEmpty } from '@mui/icons-material';
import { VOStageStatus } from 'modules/vendorOpportunity/types';
import { Box, CircularProgress, Typography } from '@mui/material';
import { RenderWithCondition } from 'components/shared/Conditional/RenderWithCondition';
import { Stage } from '../api';

const stageClassMap: Record<VOStageStatus, string> = {
  [VOStageStatus.Passed]: 'stage-passed',
  [VOStageStatus.Current]: 'stage-current',
  [VOStageStatus.Future]: 'stage-future',
  [VOStageStatus.Viewed]: 'stage-viewed',
};

const stageIconsMap: Partial<Record<VOStageStatus, ReactNode>> = {
  [VOStageStatus.Current]: <HourglassEmpty fontSize="small" />,
};

interface Props {
  stage: Stage;
  isUpdating: boolean;
  status: VOStageStatus;
  onClick?: (stage: Stage) => void;
}

export const StageBadge = ({ stage, onClick, status, isUpdating }: Props) => {
  if (isUpdating && status === VOStageStatus.Current) {
    return (
      <Box
        className={clsx('stageBadge', stageClassMap[status])}
        onClick={() => {
          onClick?.(stage);
        }}
      >
        <CircularProgress size={20} />

        <Typography component="span" variant="subtitle2">
          {stage.name}
        </Typography>
      </Box>
    );
  }

  return (
    <Box
      className={clsx('stageBadge', stageClassMap[status])}
      onClick={() => {
        onClick?.(stage);
      }}
    >
      <RenderWithCondition condition={!!stageIconsMap[status]}>{stageIconsMap[status]!}</RenderWithCondition>

      <Typography component="span" variant="subtitle2">
        {stage.name}
      </Typography>
    </Box>
  );
};
